import 'jquery';

import 'datatables.net';
import 'datatables.net-bs4';
import '../../dataTables.bootstrap4.css';

export default function initDataTables() {
	$('#portfolio-companies.investor-portfolio-companies').DataTable({
		searching: false,
		paging: false,
		info: false,
		order: [],
		columnDefs: [
			/*{ 'targets': [2, 3, 4], 'orderSequence': ['desc', 'asc'] },
			{ 'targets': [5, 6], 'orderable': false }*/
		]
	});

	$('#portfolio-companies.global-portfolio-companies').DataTable({
		searching: false,
		paging: false,
		info: false,
		order: [],
		columnDefs: [
			/*{ 'targets': [1, 2, 3, 4], 'orderSequence': ['desc', 'asc'] },
			{ 'targets': 5, 'orderable': false }*/
		]
	});

	$('#global-portfolio-investors').DataTable({
		searching: false,
		paging: false,
		info: false,
		order: [],
		columnDefs: [
			/*{ 'targets': [2, 3, 4, 5, 6, 7], 'orderSequence': ['desc', 'asc'] }*/
		]
	});
}
